import loginCarouselImage from '@/assets/images/login-carrousel-1.png';
import { LogoMainHorizontalWhite } from '@/components/brand';

const HERO_COPY = {
    title: 'Toda a avaliação em um só lugar',
    description:
        'Organize paciente, etapas da avaliação, instrumentos e laudo em um fluxo único, visual e profissional dentro do LaudoPsi.',
};

export function AuthHeroPanel() {
    return (
        <div className="relative z-10 flex size-full flex-col p-8 text-white">
            <div className="flex items-center gap-4">
                <div className="flex-shrink-0">
                    <LogoMainHorizontalWhite />
                </div>
                <div className="h-8 w-px bg-white/20" />
                <span className="whitespace-nowrap text-xs font-light leading-tight text-white/80">
                    O futuro da escrita de laudos
                </span>
            </div>

            <div className="flex flex-1 flex-col justify-center gap-6 py-8">
                <div className="relative w-full overflow-hidden rounded-[28px] border border-white/10 bg-white/10 shadow-[0_30px_80px_rgba(2,6,23,0.35)] backdrop-blur-sm">
                    <div className="absolute inset-x-12 top-0 h-20 rounded-full bg-white/10 blur-3xl" />
                    <div className="aspect-video w-full overflow-hidden rounded-[28px]">
                        <img
                            src={loginCarouselImage}
                            alt="Fluxo de avaliação com paciente, etapas e laudo dentro do LaudoPsi"
                            className="size-full object-cover"
                        />
                    </div>
                </div>

                <div className="space-y-4">
                    <h2 className="text-3xl font-semibold leading-tight">{HERO_COPY.title}</h2>
                    <p className="text-sm leading-relaxed text-white/80">{HERO_COPY.description}</p>
                </div>
            </div>
        </div>
    );
}
